import React, { useState } from "react";
import CategoryScreen from "./CategoryScreen";
import { canAccessLab } from "../utils/accessControl";
const labs = [
  {
    id: "lab1",
    name: "Cyber Lab 1 - Linux Basics",
    total: 3,
    details: {
      objective: "Introduce Linux command-line basics and navigation.",
      skillsLearned: [
        "1. Linux terminal usage",
        "2. Directory navigation",
        "3. Basic system commands"
      ],
      difficulty: "Beginner",
      category: "File Security",
      level: "foundation",
      tier: "free"
    //  image: "cyberlab-basic"   //Passing Lab level for image to beused
    }
  },
  {
    id: "lab2",
    name: "Cyber Lab 2 - File Permissions",
    total: 3,
    details: {
      objective: "Understand Linux file permissions and access control.",
      skillsLearned: [
        "1. chmod usage",
        "2. File permission concepts",
        "3. Read/write/execute control"
      ],
      difficulty: "Beginner",
      category: "File Security",
      level: "foundation",
      tier: "pro"
      
    }
  },
  {
    id: "lab3",
    name: "Cyber Lab 3 - Network Tools",
    total: 3,
    details: {
      objective: "Learn basic network diagnostic tools and connectivity checks.",
      skillsLearned: [
        "1. ping usage",
        "2. traceroute basics",
        "3. IP address identification"
      ],
      difficulty: "Beginner",
      category: "File Security",
      level: "foundation",
      tier: "premium"
    }
  },
  { id: "lab4", 
    name: "Cyber Lab 4 - Process & System Monitoring", 
    total: 3 ,
    details:{
      objective:"Understand Process & System Monitoring",
      skillsLearned: [
        "1. chmod Usage",
        "2. Numeric Permission Management",
        "3. File Access Control"
      ],
      difficulty:"Intermediate",
      category: "File Security",
      level: "Expert",
      tier: "premium"
  }
  },
   { id: "lab5", 
    name: "Cyber Lab 5 - Networking Basics",
     total: 3 ,
    details:{
      objective:"Understand Networking Basics.",
      skillsLearned:[
        "1. Execute Permission Management",
      "2. Executable File Configuration",
      "3. Controlled Execution Access"
      ],
      difficulty:"Intermediate",
      category:"File Security",
      level: "advanced",
      tier: "pro"
    }},
  { id: "lab6",
    name: "Cyber Lab 6 - Cybersecurity Directory Security  Basics",
     total: 3 ,
    details:{
      objective:"Understand Cybersecurity Directory Security Basics.",
      skillsLearned:[
        "1. Directory Creation",
        "2. Directory Permission Inspection",
        "3. Sticky Bit Configuration",
      
      ],
      difficulty:"Intermediate",
      category:"File Security",
      level: "Expert",
      tier: "pro"
    } },
  { id: "lab7", 
    name: "Cyber Lab 7 - Log & System Inspection",
     total: 2,
    details:{
      objective:"Understand Log & System Inspection",
      skillsLearned:[
        "1. Hidden File Creation",
        "2. Hidden File Management",
      ],
      difficulty:"Intermediate",
      category:"File Security",
       level: "Expert",
      tier: "premium"
    } },
  { id: "lab8", 
    name: "Cyber Lab 8 - User Management Basics", 
    total: 2,
    details:{
      objective:"Understand User Management Basics",
      skillsLearned:[
        "1. File Creation",
        "2. File Listing",
      ],
 difficulty:"Intermediate",
      category:"File Security",
       level: "Expert",
      tier: "pro"
    } 
      
  },
  { id: "lab9",
    name: "Cyber Lab 9 - User Privilege Management ",
    total: 3,
    details:{
      objective:"Understand User Privilege Management",
      skillsLearned:[
        "1. SUID Permission Configuration",
        "2. Owner Privilege Execution",
        "3. Special Permission Management",
      ],
       difficulty:"expert",
      category:"File Security",
      level: "expert",
      tier: "premium"
    }
  },
   {
       id:"lab10",
    name: "Cyber Lab 10 - Group Privilege Management ",
    total: 3,
    details:{
      objective:"Understand Group Privilege Management",
      skillsLearned:[
        "1. SGID Permission Configuration",
        "2. Group Privilege Execution",
        "3. Group Based Access Management",
      ],
       difficulty:"expert",
      category:"File Security",
      level: "Expert",
      tier: "premium"
    }
  },
   {
    id: "lab11",
  name: "Cyber Lab 11 - User Account Management",
  total: 4,
  details: {
    objective: "Introduce User Account Management.",
    skillsLearned: [
      "1. User Account Management",
      "2. Ientity Management",
      "3. Account Security Management",
      "4. User Life Cycle Management"
    ],
    difficulty: "Beginner",
    category: "User Account Security",
    level: "Expert",
      tier: "premium"
  }
  },
  {
    id: "lab12A",
  name: "Cyber Lab 12A - Authentication and Password Security",
  total: 4,
  details: {
    objective: "Understand Authentication and Password Security.",
    skillsLearned: [
      "1.	Authentication Management",
      "2.	Password Security",
      "3.	Multi-Factor Authentication (MFA)",
      "4.	Security Policy Enforcement"
    ],
    difficulty: "Intermediate",
    category: "User Account Security",
    level: "Expert",
      tier: "premium"
  }
  },
  {
    id: "lab12B",
  name: "Cyber Lab 12B - Authentication and Password Security",
  total: 4,
  details: {
    objective: "Learn Authentication and Password Security.",
    skillsLearned: [
      "1.	Authentication Management",
      "2.	Password Security",
      "3.	Multi-Factor Authentication (MFA)",
      "4.	Security Policy Enforcement"
    ],
    difficulty: "Intermediate",
    category: "User Account Security",
    level: "Expert",
      tier: "premium"
  }
  },
  {
    id: "lab12C",
  name: "Cyber Lab 12C - Authentication and Password Security",
  total: 4,
  details: {
    objective: "Advanced Authentication and Password Security.",
    skillsLearned: [
      "1.	Authentication Management",
      "2.	Password Security",
      "3.	Multi-Factor Authentication (MFA)",
      "4.	Security Policy Enforcement"
    ],
    difficulty: "Intermediate",
    category: "User Account Security",
    level: "Expert",
      tier: "premium"
  }
  },
  {
    id: "lab13",
  name: "Cyber Lab 13 - Authorization and Access Control",
  total: 4,
  details: {
    objective: "Learn Authorization and Access Control",
    skillsLearned: [
      "1.	Role-Based Access Control (RBAC)",
      "2.	Authorization Management",
      "3.	Access Governance",
      "4.	Least Privilege Implementation"
    ],
    difficulty: "Intermediate",
    category: "User Account Security",
     level: "Expert",
      tier: "premium"
  }
  },
  { id: "lab14",
  name: "Cyber Lab 14 - Group Management",
  total: 4,
  details: {
    objective: "Introduce Group Management.",
    skillsLearned: [
      "1. Group Administration",
      "2.	Permission Delegation",
      "3.	Access Control Management",
      "4.	Membership Management"
    ],
    difficulty: "Intermediate",
    category: "User Account Security",
     level: "Expert",
      tier: "premium"
  }
  },
  { id: "lab15",
  name: "Cyber Lab 15 - Privileged Account Security",
  total: 4,
  details: {
    objective: "Understand Privileged Account Security",
    skillsLearned: [
      "1.	Privileged Access Management (PAM)",
      "2.	Administrative Security",
      "3.	Privilege Monitoring",
      "4.	Access Control Enforcement"
    ],
    difficulty: "Intermediate",
    category: "User Account Security",
       level: "expert",
      tier: "premium"
  }
  },
   { id: "lab16",
  name: "Cyber Lab 16 - User Activity Monitoring",
  total: 4,
  details: {
    objective: "Learn User Activity Monitoring",
    skillsLearned: [
      "1.	User Activity Monitoring",
      "2.	Security Event Analysis",
      "3.	Audit Logging",
      "4.	Threat Detection"
    ],
    difficulty: "Intermediate",
    category: "User Account Security",
       level: "expert",
      tier: "premium"
  }
  },
   { id: "lab17",
  name: "Cyber Lab 17 - Identity and Access Management (IAM)",
  total: 4,
  details: {
    objective: "Learn Identity and Access Management (IAM)",
    skillsLearned: [
      "1.	Identity and Access Management (IAM)",
      "2.	Directory Services Administration",
      "3.	LDAP Fundamentals",
      "4.	Enterprise Access Control"
    ],
    difficulty: "Intermediate",
    category: "User Account Security",
       level: "expert",
      tier: "premium"
  }
  },
   { id: "lab18",
  name: "Cyber Lab 18 - Privileged Account Security",
  total: 3,
  details: {
    objective: "Understand Linux File Permissions",
    skillsLearned: [
      "Privileged Access Management",
      "Administrative Account Security",
      "Least Privilege Implementation"
    ],
    difficulty: "Intermediate",
    category: "User Account Security",
       level: "expert",
      tier: "premium"
  }
  },
   { id: "lab19",
  name: "Cyber Lab 19 - Privileged Account Security",
  total: 3,
  details: {
    objective: "Understand Linux File Permissions",
    skillsLearned: [
      "Privileged Access Management",
      "Administrative Account Security",
      "Least Privilege Implementation"
    ],
    difficulty: "Intermediate",
    category: "User Account Security",
       level: "expert",
      tier: "premium"
  }
  },
   { id: "lab20",
  name: "Cyber Lab 20 - Privileged Account Security",
  total: 3,
  details: {
    objective: "Understand Linux File Permissions",
    skillsLearned: [
      "Privileged Access Management",
      "Administrative Account Security",
      "Least Privilege Implementation"
    ],
    difficulty: "Intermediate",
    category: "User Account Security",
       level: "expert",
      tier: "premium"
  }
  },
   { id: "lab21",
    name: "Cyber Lab 21 - User Privilege Management ",
    total: 3,
    details:{
      objective:"Understand Linux File Permission",
      skillsLearned:[
        "SUID Permission Configuration",
        "Owner Privilege Execution",
        "Special Permission Management",
      ],
       difficulty:"Beginner",
      category:"Platform Security",
       level: "Expert",
      tier: "premium"
    }
  },
  { id: "lab31",
    name: "Cyber Lab 21 - User Privilege Management ",
    total: 3,
    details:{
      objective:"Understand Linux File Permission",
      skillsLearned:[
        "SUID Permission Configuration",
        "Owner Privilege Execution",
        "Special Permission Management",
      ],
       difficulty:"Beginner",
      category:"Network Security",
      level: "Expert",
      tier: "premium"
    }
  },
  { id: "lab41",
    name: "Cyber Lab 41 - User Privilege Management ",
    total: 3,
    details:{
      objective:"Understand Linux File Permission",
      skillsLearned:[
        "SUID Permission Configuration",
        "Owner Privilege Execution",
        "Special Permission Management",
      ],
       difficulty:"Beginner",
      category:"Network Security",
       level: "Expert",
      tier: "premium"
    }
  },
  { id: "lab51",
    name: "Cyber Lab 51 - User Privilege Management ",
    total: 3,
    details:{
      objective:"Understand Linux File Permission",
      skillsLearned:[
        "SUID Permission Configuration",
        "Owner Privilege Execution",
        "Special Permission Management",
      ],
       difficulty:"Beginner",
      category:"Data Security",
       level: "Expert",
      tier: "premium"
    }
  },
  { id: "lab61",
    name: "Cyber Lab 61 - User Privilege Management ",
    total: 3,
    details:{
      objective:"Understand Linux File Permission",
      skillsLearned:[
        "SUID Permission Configuration",
        "Owner Privilege Execution",
        "Special Permission Management",
      ],
       difficulty:"Beginner",
      category:"Application Security",
       level: "Expert",
      tier: "premium"
    }
  },
  { id: "lab71",
    name: "Cyber Lab 71 - User Privilege Management ",
    total: 3,
    details:{
      objective:"Understand Linux File Permission",
      skillsLearned:[
        "SUID Permission Configuration",
        "Owner Privilege Execution",
        "Special Permission Management",
      ],
       difficulty:"Beginner",
      category:"End Point Security Security",
       level: "Expert",
      tier: "premium"
    }
  },
  { id: "lab81",
    name: "Cyber Lab 81 - User Privilege Management ",
    total: 3,
    details:{
      objective:"Understand Linux File Permission",
      skillsLearned:[
        "SUID Permission Configuration",
        "Owner Privilege Execution",
        "Special Permission Management",
      ],
       difficulty:"Beginner",
      category:"Identity Management",
       level: "Expert",
      tier: "premium"
    }
  },
  { id: "lab91",
    name: "Cyber Lab 91 - User Privilege Management ",
    total: 3,
    details:{
      objective:"Understand Linux File Permission",
      skillsLearned:[
        "SUID Permission Configuration",
        "Owner Privilege Execution",
        "Special Permission Management",
      ],
       difficulty:"Beginner",
      category:"Cloud Security",
       level: "Expert",
      tier: "premium"
    }
  },
  { id: "lab101",
    name: "Cyber Lab 101 - User Privilege Management ",
    total: 3,
    details:{
      objective:"Understand Linux File Permission",
      skillsLearned:[
        "SUID Permission Configuration",
        "Owner Privilege Execution",
        "Special Permission Management",
      ],
       difficulty:"Beginner",
      category:"Policy & Compliance Management",
       level: "Expert",
      tier: "premium"
    }
  },
  { id: "lab111",
    name: "Cyber Lab 111 - User Privilege Management ",
    total: 3,
    details:{
      objective:"Understand Linux File Permission",
      skillsLearned:[
        "SUID Permission Configuration",
        "Owner Privilege Execution",
        "Special Permission Management",
      ],
       difficulty:"Beginner",
      category:"Forensic Analysis",
       level: "Expert",
      tier: "premium"
    }
  },
  { id: "lab121",
    name: "Cyber Lab 121 - User Privilege Management ",
    total: 3,
    details:{
      objective:"Understand Linux File Permission",
      skillsLearned:[
        "SUID Permission Configuration",
        "Owner Privilege Execution",
        "Special Permission Management",
      ],
       difficulty:"Beginner",
      category:"Hacking Labs",
       level: "Expert",
      tier: "premium"
    }
  },
];

export default function Dashboard({
  user,
  globalScore,
  globalCompleted,
  labProgress = {},
  onStartLab,
  activeLab,
  onLogout   
}) {
  const [selectedCategory, setSelectedCategory] = useState(null);

const categories = Array.from(
  new Set(labs.map(l => l.details?.category || "Others"))
).sort();

const visibleLabs = selectedCategory
  ? labs.filter(lab => lab.details?.category === selectedCategory)
  : labs;

  return (
    <div style={styles.container}>

      {/* HEADER */}
  <div style={styles.header}>
  <h1>🧠 Cybersecurity Labs Dashboard</h1>
  
   <button onClick={onLogout} style={styles.logout}>
          Logout
        </button>

  <div style={styles.stats}>
    <div style={styles.card}>
      <h3>🏆 Total Score</h3>
      <p>{globalScore}</p>
    </div>

    <div style={styles.card}>
      <h3>✅ Tasks Completed</h3>
      <p>{globalCompleted}</p>
    </div>
  </div>
</div>

      {/* CATEGORY / LAB VIEW SWITCH */}
      {!selectedCategory ? (
        <CategoryScreen
          categories={categories}
          labs={labs}
          onSelectCategory={setSelectedCategory}
        />
      ) : (
        <>
          <div style={styles.backContainer}>
            <button
              style={styles.backButton}
              onClick={() => setSelectedCategory(null)}
            >
              ← Back to Categories
            </button>
          </div>

          <h2 style={{ marginTop: 30 }}>
            📚 {selectedCategory}
          </h2>
          
              <div style={styles.labGrid}>
  {visibleLabs.map((lab) => {
  //
  const labState = labProgress?.labs?.[lab.id] || {};
  const completedTasks = labState.completedTasks || 0;
  const score = labState.score || 0;
  const isCompleted = labState.completed || false;

  const progress =
    lab.total > 0
      ? (completedTasks / lab.total) * 100
      : 0;

  const allowed = canAccessLab(user, lab);
  const details = lab.details;
 
  //
              return (
                <div key={lab.id} style={styles.labCard}>

                  <h3>
                  {lab.name}

                   </h3>

                  <div style={styles.progressBar}>
                    <div
                      style={{
                        ...styles.progressFill,
                        width: `${progress}%`
                      }}
                    />
                  </div>
{isCompleted && (
  <div
    style={{
      color: "#4caf50",
      fontWeight: "bold",
      marginTop: 10
    }}
  >
    ✅ Completed
  </div>
)}
                  <div style={styles.detailsBox}>
                    {details ? (
                      <>
                        <span style={styles.badge}>
                          📂 {details.category || "Others"}
                        </span>

                        <span
                          style={{
                            ...styles.badge,
                            background:
                              details.difficulty === "Beginner"
                                ? "#2e7d32"
                                : details.difficulty === "Intermediate"
                                ? "#ef6c00"
                                : "#c62828"
                          }}
                        >
                          {details.difficulty || "N/A"}
                        </span>

                        <p style={styles.objective}>
                          {details.objective}
                        </p>

                        <ul style={styles.skills}>
                          {details.skillsLearned?.slice(0, 3).map((skill, i) => (
                            <li key={i}>✔ {skill}</li>
                          ))}
                        </ul>
                      </>
                    ) : (
                      <p style={{ color: "#888" }}>
                        Details coming soon...
                      </p>
                    )}
                  </div>
                
                  <button
  disabled={!allowed}
  
  title={!allowed ? "You do not have access to this lab" : ""}
  onClick={() => allowed && onStartLab(lab.id)}
  style={{
    ...styles.button,
    background: !allowed
      ? "#9e9e9e"
      : activeLab === lab.id
      ? "#ff9800"
      : "#4caf50",
    cursor: !allowed ? "not-allowed" : "pointer"
  }}
>
 {
  allowed
    ? "Start Lab"
    : `Locked 🔒 (${lab.details.level || "Unknown"} level required)`
}
</button>

                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}

/* ================= UI STYLES ================= */

const styles = {
  container: {
    padding: 20,
    background: "#0d1117",
    color: "#fff",
    minHeight: "100vh",
    fontFamily: "Arial"
  },

  header: {
    borderBottom: "1px solid #333",
    paddingBottom: 20
  },

  stats: {
    display: "flex",
    gap: 20,
    marginTop: 10
  },

  card: {
    background: "#161b22",
    padding: 15,
    borderRadius: 10,
    minWidth: 150
  },
logout: {
    background: "red",
    color: "white",
    padding: "8px 15px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer"
  },
  labGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
    gap: 20,
    marginTop: 20
  },

  labCard: {
    background: "#161b22",
    padding: 20,
    borderRadius: 10,
    border: "1px solid #333",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between"
  },

  progressBar: {
    height: 8,
    background: "#333",
    borderRadius: 5,
    marginTop: 10,
    overflow: "hidden"
  },

  progressFill: {
    height: "100%",
    background: "#4caf50",
    transition: "width 0.3s ease"
  },

  detailsBox: {
    marginTop: 15,
    padding: 10,
    background: "#0d1117",
    borderRadius: 8,
    border: "1px solid #333"
  },

  badge: {
    display: "inline-block",
    marginRight: 8,
    padding: "3px 8px",
    borderRadius: 6,
    fontSize: 11,
    background: "#30363d"
  },

  objective: {
    fontSize: 12,
    marginTop: 8,
    color: "#c9d1d9"
  },

  skills: {
    marginTop: 8,
    fontSize: 12,
    paddingLeft: 15,
    color: "#8b949e"
  },
  backContainer: {
  marginTop: 20
},

backButton: {
  background: "#2196f3",
  color: "#fff",
  border: "none",
  padding: "10px 16px",
  borderRadius: 8,
  cursor: "pointer"
},

  button: {
    marginTop: 15,
    padding: "8px 12px",
    border: "none",
    borderRadius: 6,
    color: "#fff",
    cursor: "pointer"
  }
};